/**
 * /dashboard/bulk-imports — Bulk-import history list (G7.5) — HR-admin
 * landing page.
 *
 * Backend: GET /api/v1/bulk-imports. HR-admin only.
 *
 * Migration note (Phase 3f — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/bulk-imports/page.tsx. Swaps:
 *   - "use client" dropped
 *   - next/link Link → @tanstack/react-router Link
 */

import { createFileRoute, Link , useParams} from "@tanstack/react-router";
import { Plus, Upload } from "lucide-react";
import { PageHeader } from "@/components/shared/page-header";
import { BulkImportRoleGate } from "@/components/bulk-imports/bulk-import-role-gate";
import { BulkImportList } from "@/components/bulk-imports/bulk-import-list";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/bulk-imports/")({
  component: BulkImportsRoute,
});

function BulkImportsRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  return (
    <BulkImportRoleGate>
      <PageHeader
        title="Bulk Import"
        description="Day-0 onboarding tool — bulk-load employees, leave balances and training assignments from CSV."
        actions={
          <Button asChild className="gap-1.5" data-testid="bulk-imports-list-new-button">
            <Link to="/app/$tenantSlug/bulk-imports/new" params={{ tenantSlug }}>
              <Plus aria-hidden className="h-4 w-4" />
              New import
            </Link>
          </Button>
        }
      />
      <div className="flex items-center gap-2 text-sm text-muted-foreground sm:hidden">
        <Upload aria-hidden className="h-4 w-4" />
        <span>HR-admin view</span>
      </div>
      <BulkImportList />
    </BulkImportRoleGate>
  );
}
